import React from 'react';
import { AddressContainer } from '../../../../../../common/address/containers/address.container';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { BillingAddressContainer } from '../../../../../../common/billing-address/containers/billing-address.container';
import { ShippingAddressContainer } from '../../../../../../common/shipping-address/containers/shipping-address.container';

export const StoreAddressComponent = ({ selectedStore, handleInnerbasicFormChange, selectedAddress, onInnerFormChange }: any) => (
          <>

       
                <AddressContainer
                    isAddress
                    onInnerFormChange={onInnerFormChange}
                    selectedAddress={selectedAddress}
                   
                />

           
          <AccordionContainer
              child={
                <>
               <div>
                <InputContainer
                    label="Use PrimaryAddress As BillingAddress"
                    name="IsUsePrimaryAddressAsBillingAddress"
                    onValueChange={(event: any) => {
                      handleInnerbasicFormChange(
                        event,
                        'IsUsePrimaryAddressAsBillingAddress'
                      )
                    }}
                    type="checkbox"
                    value={selectedStore?.IsUsePrimaryAddressAsBillingAddress}
                />
           

            {!selectedStore?.IsUsePrimaryAddressAsBillingAddress &&
                <BillingAddressContainer
                isAddress
                    onInnerFormChange={onInnerFormChange}
                    selectBillingAddress={selectedAddress}
                />}
               </div>
                </>
  }
              expandedPanel="billingaddressInfo"
              headerTitle="Billing Address"
          />
           <AccordionContainer
               child={
                 <>
                 <div>
                <InputContainer
                    label="Use Primary Address As ShippingAddress"
                    name="IsUsePrimaryAddressAsShippingAddress"
                    onValueChange={(event: any) => {
                      handleInnerbasicFormChange(
                        event,
                        'IsUsePrimaryAddressAsShippingAddress'
                      )
                    }}
                    type="checkbox"
                    value={selectedStore?.IsUsePrimaryAddressAsShippingAddress}
                />
          
            {!selectedStore?.IsUsePrimaryAddressAsShippingAddress &&
                <ShippingAddressContainer
                    isAddress
                    onInnerFormChange={onInnerFormChange}
                    selectShippingAddress={selectedAddress}
                />}
               </div>
                </>
  }
               expandedPanel="shippingaddressInfo"
               headerTitle="Shipping Address"
           />
</>
)
export default StoreAddressComponent;
